<plotly-plot #thePlot
             [data]="data"
             [layout]="layout"
             [config]="config"
></plotly-plot>
